





































































import Component from 'vue-class-component'
import { Prop, Vue } from 'vue-property-decorator'
import CalculatedDelivery from '@/dto/calculate/CalculatedDelivery'
import DictionariesService from '@/services/DictionariesService'

@Component({ inheritAttrs: false })
export default class CalculatorDeliveriesItem extends Vue {
  @Prop(Object) delivery: CalculatedDelivery

  get terms(): string {
    const terms = Object.values(this.delivery.terms)
      .filter(term => term)
      .sort((a, b) => a - b)

    const uniqueTerms = Array.from(new Set(terms))

    return `${uniqueTerms.join('...')} дн.`
  }

  get usdSymbol(): string {
    const currency = DictionariesService.currencies[this.delivery.currency]
    return currency ? currency.symbol : '$'
  }

  get originalSymbol(): string {
    const code = this.delivery.originalCurrency || this.delivery.currency
    const currency = DictionariesService.currencies[code]
    return currency ? currency.symbol : code
  }

  get weight() {
    if (this.delivery.weightType === 'volume') {
      return {
        cls: 'volume',
        label: 'габ. вес',
        tooltip: 'Расчёт по габаритному (объёмному) весу',
      }
    }

    return {
      cls: 'natural',
      label: 'факт. вес',
      tooltip: 'Расчёт по фактическому весу',
    }
  }
}
